import React from "react";
import { GALLERY } from "../data/mock";
import { useLightbox } from "../components/Lightbox";
import { useLang } from "../context/LanguageContext";

const GalleryPage = () => {
  const { t } = useLang();
  const { openAt, lightbox } = useLightbox(GALLERY);

  return (
    <main className="bg-white dark:bg-black transition-colors">
      <section className="bg-[#800000] py-16 md:py-20 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10 pointer-events-none">
          <div className="absolute -top-20 -left-20 w-80 h-80 bg-[#14532d] rounded-full blur-3xl" />
          <div className="absolute -bottom-20 -right-20 w-80 h-80 bg-white rounded-full blur-3xl" />
        </div>
        <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-3">{t("gallery_page.title")}</h1>
          <p className="text-white/90 text-lg">{t("gallery_page.subtitle")}</p>
          <div className="flex items-center justify-center gap-2 mt-5">
            <div className="h-1 w-12 bg-white rounded-full" />
            <div className="h-1 w-6 bg-[#14532d] rounded-full" />
          </div>
        </div>
      </section>

      <section className="py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {GALLERY.map((g, i) => {
              const caption = g.captionKey ? t(`gallery_captions.${g.captionKey}`) : g.caption || "";
              return (
                <button
                  key={g.id}
                  onClick={() => openAt(i)}
                  className="group relative overflow-hidden rounded-lg shadow-md hover:shadow-2xl transition-all duration-300 bg-slate-100 dark:bg-zinc-900 aspect-[4/3]"
                  aria-label={`Open ${caption}`}
                >
                  <img src={g.src} alt={caption} loading="lazy" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#800000]/95 via-[#800000]/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  <div className="absolute bottom-0 left-0 right-0 p-4 text-left translate-y-3 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
                    <p className="text-white text-sm md:text-base font-semibold">{caption}</p>
                    <div className="flex items-center gap-2 mt-1">
                      <div className="h-0.5 w-8 bg-emerald-300" />
                      <span className="text-emerald-200 text-xs uppercase tracking-wider">{t("gallery_page.view")}</span>
                    </div>
                  </div>
                  <div className="absolute top-3 right-3 bg-black/40 backdrop-blur text-white text-xs font-semibold px-2 py-1 rounded">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                </button>
              );
            })}
          </div>

          <div className="text-center mt-12">
            <p className="text-slate-600 dark:text-slate-400 text-sm">{t("gallery_page.hint")}</p>
          </div>
        </div>
      </section>

      {lightbox}
    </main>
  );
};

export default GalleryPage;
